require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-neusiedl-halbturn.json") })
        }
      }, "path---betreuungseinrichtungen-neusiedl-halbturn");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-neusiedl-halbturn!./.cache/json/betreuungseinrichtungen-neusiedl-halbturn.json
// module id = 951
// module chunks = 231608221292675